export const PERCENTAGE_SMALL_VALUE_DEFAULT_WIDTH = 48;
export const SKELETON_SMALL_VALUE_DEFAULT_WIDTH = 100;
export const PROJECTED_LABEL = "Projected";
